import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import {
  COMMON_PERMISSIONS,
  MODULES_LIST,
  SUB_MODULES_LIST,
} from "../../../utils/helper";
import ManageDesignation from "../../main/configuration/manageDesignation/page";
import CommonRoute from "../commonRoute";
import Role from "../../main/configuration/manageRole/page";
import ManageJobOpening from "../../main/recuritment/jobOpening.jsx/page";
import AddJobOpening from "../../main/recuritment/jobOpening.jsx/addOpening";
import JobOpeningDetail from "../../main/recuritment/jobOpening.jsx/profile/page";
import ManageCandidates from "../../main/recuritment/candidates/page";
import CandidateProfile from "../../main/recuritment/candidates/candidateProfile/page";
import InterviewList from "../../main/recuritment/interviewSchedule/page";

const recruitmentRoute = [

  {
    path: "job-opening",
    element: <ManageJobOpening />,
    // access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.RECRUITMENT,
    subModule: SUB_MODULES_LIST.RECRUITMENT.JOB_OPENING,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.DEPARTMENT,
  },
  {
    path: "job-opening/:action?/:id?",
    element: <AddJobOpening />,
    // access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.RECRUITMENT,
    subModule: SUB_MODULES_LIST.RECRUITMENT.JOB_OPENING,
    // subModule: SUB_MODULES_LIST.BASIC_SETUP.DESIGNATION,
  },
  {
    path: "job-opening/detail/:id?",
    element: <JobOpeningDetail />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.RECRUITMENT,
    subModule: SUB_MODULES_LIST.RECRUITMENT.JOB_OPENING,
   
  },
   {
    path: "candidates",
    element: <ManageCandidates />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.RECRUITMENT,
    subModule: SUB_MODULES_LIST.RECRUITMENT.JOB_APPLICATION,
  },
  {
    path: "candidates/detail/:id?",
    element: <CandidateProfile />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.RECRUITMENT,
    subModule: SUB_MODULES_LIST.RECRUITMENT.JOB_APPLICATION,
  },
  {
    path: "interview-schedule",
    element: <InterviewList />,
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.RECRUITMENT,
    subModule: SUB_MODULES_LIST.RECRUITMENT.JOB_INTERVIEW,
  },
];

export default function renderRecruitmentRoutes() {
  const renderRoute = (route, access = false) => {
    if (route.children && route.children.length > 0) {
      return (
        <Route
          key={route.path}
          path={route.path}
          element={
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              // access={route.access}
              path={route.path}
            >
             
            </ProtectedRoute>
          }
        >
          {/* Render child routes without extra permission checks */}
          {route.children.map((child) => (
            <Route key={child.path} path={child.path} element={child.element} />
          ))}
        </Route>
      );
    }
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          access ? (
            route.element
          ) : (
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              // access={route.access}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          )
        }
      />
    );
  };
  return recruitmentRoute.map((route) => renderRoute(route));
}
